<template>
	<div>
		<div class="margin-left allwaud">
			<div class="bg-white padding-sm radius top">
				<div class="text-32 text-000 text-bold padding-bottom-sm padding-top solid-bottom text-left">{{title}}</div>
				<div class="flex justify-between align-center">
					<div class="margin-top-sm">
						<div class="flex align-center justify-between" v-if="user">
							<p class="flex align-center">
								<img :src="user.avatar" class="block-30">
								<span class="text-sm text-333 margin-left-xs">{{user.nick_name}}</span>
							</p>
							<div class="flex align-center margin-left-xs">
								<img v-if="user.is_real == 2" class="" src="https://manage.ciiply.com/web/static/home/authentication.png"  style="width: 16px;height: 20px;" >
								<img v-if="user.is_real_company == 2" class="" src="https://manage.ciiply.com/web/static/home/enterprise.png"  style="width: 16px;height: 20px;" >
								<img v-else class="" src="https://manage.ciiply.com/web/static/home/random.png"  style="width: 16px;height: 20px;" >
								<p class="text-sm text-theme margin-left-xs" >{{user.is_real_company == 2?'企业已认证':user.is_real == 2?'个人已认证':'未认证'}}</p>
							</div>
						</div>
						<div class="flex align-center justify-between margin-top-xs">
							<p>
								<i class="el-icon-location-outline"></i>
								<span class="text-sm text-666">{{area}}</span>
							</p>
							<p>
								<span class="text-sm text-999">费用预算</span>
								<span class="text-prices">￥{{price}}/月</span>
							</p>
						</div>
					</div>
					<div class="flex align-center">
						<div class="colt flex align-center justify-center pointer" @click="del()">
							<p class="margin-left-xs text-666">删除</p>
						</div>
						<div class="callbtns flex align-center justify-center margin-left-xs pointer">
							<p class="text-white margin-left-xs">修改信息</p>
						</div>
					</div>
				</div>
				<p v-if="status == 1" class="btn btn2">审核中</p>
				<p v-if="status == 2" class="btn btn3">未通过</p>
				<p v-if="status == 3" class="btn btn1">已发布</p>
			</div>
			<div class="bg-white margin-top padding-sm radius">
				<p class="title text-left padding-left-sm">详情</p>
				<div class="text-left">{{content}}</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		components: {
			
		},
		name: '',
		data() {
			return {
				id:0,//
				title:'',//标题
				content:'',//内容
				user:null,
				area:'',
				price:'',
				status:'',//状态
			}
		},
		created() {
			Bus.$on('tendid',data=>{
				console.log('-----',data);
				this.id = data
				this.getdetail()
			})
			
		},
		methods: {
			getdetail(){
				this.ajax('get', '/api/pc/bidding/getInfo', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						this.title = res.data.title
						this.content = res.data.content
						this.area = res.data.area
						this.status = res.data.status
						this.user = res.data.user
						this.price = res.data.budget
						this.$forceUpdate()
					}else{
						this.$message(res.msg);
					}
				})
			},
			//通知center 跳转对应页面
			godetail(index,typeone){
				let one = typeone?typeone:''
				let type = {
					type:index,
					typeone:one
				}
				this.$emit('gettype',type)
			},
			del(){
				this.ajax('post', '/api/pc/bidding/deleteBidding', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						this.$message.success(res.msg);
						this.godetail('tender')
						setTimeout(()=>{
							Bus.$emit('tendel')
						},20)
					}else{
						this.$message(res.data.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.text-32{
		font-size: 32px;
	}
	.allwaud{
		width: 920px;
	}
	//状态按钮
	.top{
		position: relative;
		.btn{
			position: absolute;
			top: 0;
			right: 0;
			width: 63px;
			height: 29px;
			line-height: 29px;
			border-radius: 0px 20px 0px 10px;
		}
		.btn1{
			background: rgba(11, 131, 124, 0.1);
			color: #0B837C;
		}
		.btn2{
			background: #FEF5E9;
			color: #FAA74F;
		}
		.btn3{
			background: #EAF0FC;
			color: #568EEB;
		}
	}
	//状态按钮 end
	.title{
		position: relative;
		font-size: 22px;
		&:before{
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 6px;
			height: 26px;
			background: #09827B;
			content: '';
			
		}
	}
	.block-30{
		width: 30px;
		height: 30px;
		border-radius: 50%;
	}
	.colt{
		width: 111px;
		height: 45px;
		background: #FFFFFF;
		border: 1px solid #E6E6E6;
		border-radius: 23px;
	}
	.tip{
		padding: 12px 28px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(204,204,204,0.3000);
		border-radius: 20px;
	}
	.callbtns{
		width: 193px;
		height: 45px;
		background: #0B837C;
		border-radius: 23px;
		.call-icon{
			width: 19px;
			height: 19px;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/my/tender/detail.vue